import { render, staticRenderFns } from "./ThgCombiDeal.vue?vue&type=template&id=35425246&scoped=true"
import script from "./ThgCombiDeal.vue?vue&type=script&lang=ts"
export * from "./ThgCombiDeal.vue?vue&type=script&lang=ts"
import style0 from "./ThgCombiDeal.vue?vue&type=style&index=0&id=35425246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35425246",
  null
  
)

export default component.exports